import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "onClick"]
const _hoisted_2 = { style: {"padding":"20px"} }

import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  
  import { allComplaint,modifyStatus,delComplaint } from '../../api'
  
  
  
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

  const search = reactive({ 
    state: "0", 
  })
  
  
  const loading = ref(false);
  
  const selectedKeys = ref([]);
  
  const dataSource = ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });
  
  const columns = ref([ 
    { title: "图片", key: "imgs", align: "center", customSlot: "imgs" },
    { title: "标题", key: "title", align: "center" },
    { title: "简介", key: "summary", align: "center"},
    { title: "状态", key: "state", align: "center", customSlot: "state", width: "150px" },
    { title: "投诉信息", key: "remark", align: "center" },
    { title: "发布者", key: "userName", align: "center" },
    { title: "投诉者", key: "complainant", align: "center" },
    { title: "注册时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  
  
  const getAllComplaint = () => {
    loading.value = true;
    var data = { "page": page.current, "limit": page.limit,"state": search.state};
    allComplaint(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  
  getAllComplaint();
  
  const change = (page: any) => {
    getAllComplaint();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
  
   
  //搜索
  const searchUser=()=>{
    page.current=1; 
    getAllComplaint();
  }
  
  
//删除
  const deleteComplaint=(row: any)=>{

    data = {"id": row.id};
    delComplaint(JSON.stringify(data) ).then((res: any) => { 
     if (res != "" && res.code == 0) {
       layer.msg("操作成功", { icon : 1, time: 1000})
       getAllComplaint();
     } else {
       layer.msg(res.msg, { icon : 2, time: 1000})
     }
   })
  }


  //状态
var data:any;

const changeState = (row: any, value: any) => {
   data = { "state": value, "id": row.id,"key":row.loufengId };
  if(value==1){
    visible11.value = !visible11.value;

  }else{
    addReviewComplaint(JSON.stringify(data))
  }
 
}

const addReviewComplaint=(data:any)=>{

  modifyStatus(data).then((res: any) => {
     
    if (res != "" && res.code == 0) {

      layer.msg("操作成功", { icon : 1, time: 1000})
      getAllComplaint();
    } else {
      layer.msg(res.msg, { icon : 2, time: 1000})
    }
  })

}


const remark =ref("");

const visible11 = ref(false);

const action11 = ref([
    {
        text: "确认",
        callback: () => { 
          data.keyword=remark.value; 
          addReviewComplaint(JSON.stringify(data)) 
          visible11.value = !visible11.value;
        }
    },
    {
        text: "取消",
        callback: () => {
          visible11.value = !visible11.value;
        }
    }
])
   
  
  
return (_ctx: any,_cache: any) => {
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_col = _resolveComponent("lay-col")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_col, { md: "24" }, {
          default: _withCtx(() => [
            _createVNode(_component_lay_panel, null, {
              default: _withCtx(() => [
                _createVNode(_component_lay_form, {
                  model: search,
                  style: {"text-align":"start"},
                  size: "sm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lay_form_item, {
                      label: "状态",
                      prop: "state",
                      mode: "inline"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_select, {
                          modelValue: search.state,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.state) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_lay_select_option, {
                              value: "0",
                              label: "全部"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "1",
                              label: "未处理"
                            }),
                            _createVNode(_component_lay_select_option, {
                              value: "2",
                              label: "已处理"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_lay_form_item, { mode: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_button, {
                          type: "primary",
                          size: "sm",
                          onClick: searchUser
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("查询")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createVNode(_component_lay_table, {
                  page: page,
                  height: '100%',
                  columns: columns.value,
                  loading: loading.value,
                  "data-source": dataSource.value,
                  "selected-keys": selectedKeys.value,
                  "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
                  onChange: change,
                  onSortChange: sortChange
                }, {
                  imgs: _withCtx(({ row }) => [
                    _createElementVNode("img", {
                      src: row.imgs.split(',')[0],
                      onClick: ($event: any) => (_ctx.signleImg(row.imgs.split(',')[0])),
                      style: {"width":"62.9px","height":"80px"}
                    }, null, 8, _hoisted_1)
                  ]),
                  state: _withCtx(({ row }) => [
                    _createVNode(_component_lay_select, {
                      modelValue: row.state,
                      "onUpdate:modelValue": ($event: any) => ((row.state) = $event),
                      placeholder: "请选择"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_lay_select_option, {
                          value: 0,
                          onClick: ($event: any) => (changeState(row,row.state)),
                          label: "待处理"
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_lay_select_option, {
                          value: 1,
                          onClick: ($event: any) => (changeState(row,row.state)),
                          label: "下架楼凤"
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_lay_select_option, {
                          value: 2,
                          onClick: ($event: any) => (changeState(row,row.state)),
                          label: "不属实"
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  operator: _withCtx(({ row }) => [
                    _createVNode(_component_lay_button, {
                      size: "xs",
                      type: "danger",
                      onClick: ($event: any) => (deleteComplaint(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["page", "columns", "loading", "data-source", "selected-keys"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['400px', '280px'],
      btn: action11.value,
      title: "说明"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_lay_form, {
            model: remark.value,
            ref: "layFormRef11"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "说明",
                prop: "desc"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入说明",
                    modelValue: remark.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((remark).value = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})